import { render, staticRenderFns } from "./ClosedTradesView.vue?vue&type=template&id=218245e6&"
import script from "./ClosedTradesView.vue?vue&type=script&lang=js&"
export * from "./ClosedTradesView.vue?vue&type=script&lang=js&"
import style0 from "./ClosedTradesView.vue?vue&type=style&index=0&id=218245e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports